export const FORM_CUSTOMER_DATA = () => {
  return [
    {
      name: 'telephone',
      type: 'INPUT_PHONE',
      placeholder: '',
      label: 'เบอร์ติดต่อ (กรอกเบอร์ติดต่อแล้วกด Enter)',
      disabled: true,
      rules: {
        required: true,
        pattern: /^[0-9]{10}$/,
      },
      maxLength: 10,
    },
    {
      name: 'fullName',
      type: 'INPUT',
      disabled: true,
      placeholder: '',
      label: 'ชื่อ - นามสกุล',
      rules: {
        required: true,
      },
    },
    {
      name: 'createDate',
      label: 'วันที่เริ่มรับประกัน',
      type: 'DATE_PICKER',
      placeholder: '',
      format: 'YYYY-MM-DD',
      disabled: true,
    },
    {
      name: 'expireDate',
      label: 'วันหมดอายุ',
      type: 'DATE_PICKER',
      format: 'YYYY-MM-DD',
      placeholder: '',
      disabled: true,
    },
  ];
};

export const FORM_PRODUCT_DATA = ({ mobileBrandList, channelBuyList }) => {
  const accept = ['image/jpeg', 'image/png', 'image/jpg', 'image/bmp'];
  return [
    {
      name: 'barcodeShortcut',
      type: 'INPUT_BARCODE',
      disabled: true,
      placeholder: '',
      label: 'Barcode',
      rules: {
        required: true,
        pattern: /^[0-9]{9}$/,
      },
      maxLength: 9,
    },
    {
      name: 'productId',
      type: 'HIDDEN',
    },
    {
      name: 'productName',
      type: 'INPUT',
      placeholder: '',
      label: 'ชื่อสินค้า',
      disabled: true,
      rules: {
        required: true,
      },
    },
    {
      name: 'productTypeName',
      type: 'INPUT',
      placeholder: '',
      label: 'ประเภทของสินค้า',
      disabled: true,
      rules: {
        required: true,
      },
    },
    {
      name: 'mobileBrandId',
      type: 'DROPDOWN',
      placeholder: '',
      label: 'ยี่ห้อ',
      disabled: true,
      properties: {
        options: mobileBrandList || [],
      },
      rules: {
        required: true,
      },
    },
    {
      name: 'mobileModelName',
      type: 'INPUT',
      placeholder: '',
      disabled: true,
      label: 'รุ่น',
      rules: {
        required: true,
      },
    },
    {
      name: 'channelBuyId',
      type: 'DROPDOWN',
      placeholder: '',
      disabled: true,
      label: 'ช่องทางการซื้อขาย',
      properties: {
        options: channelBuyList || [],
      },
      rules: {
        required: true,
      },
    },
    {
      name: 'pictureInfo',
      type: 'TEXT',
      placeholder: '',
      label: 'ชนิดรูปภาพที่ต้องการ (.png, .jpg, .jpeg, .bmp)',
    },

    {
      name: 'invImageUrl',
      type: 'UPLOAD',
      label: 'รูปใบเสร็จ',
      listType: 'picture-card',
      span: 12,
      maxCount: 1,
      accept: accept.join(','),
      rules: {
        required: true,
      },
    },
    {
      name: 'packageImageUrl',
      type: 'UPLOAD',
      label: 'รูปสินค้า',
      listType: 'picture-card',
      span: 12,
      maxCount: 1,
      accept: accept.join(','),
      rules: {
        required: true,
      },
    },
  ];
};
export const FORM_EDIT_EXPIRED = () => {
  const span = 24;
  return [
    {
      name: 'warrantyId',
      type: 'HIDDEN',
    },
    {
      name: 'expireDate',
      label: 'วันหมดอายุ',
      type: 'DATE_PICKER',
      format: 'YYYY-MM-DD',
      placeholder: '',
      span,
      rules: {
        required: true,
      },
      disabled: true,
    },
    {
      name: 'remark',
      label: 'หมายเหตุ (ระบุได้ไม่เกิน 500 ตัวอักษร)',
      type: 'INPUT_AREA',
      placeholder: '',
      rules: {
        required: true,
        maxLength: 500,
      },
      span,
      disabled: true,
    },
  ];
};
